import { List } from 'immutable';
import { createSelector } from 'reselect';
import { STATE_NAME } from './constants';

export const getStateSlice = state => state.get(STATE_NAME);

export const getIngredientEntriesMap = state =>
  getStateSlice(state).get('ingredientEntries');

export const getIngredientEntries = createSelector(
  getIngredientEntriesMap,
  ingredientEntriesMap => ingredientEntriesMap.toList()
);

export const getIngredientEntry = id =>
  createSelector(
    getIngredientEntriesMap,
    ingredientEntriesMap => ingredientEntriesMap.get(id)
  );

export const getIngredientEntriesByIds = ids =>
  createSelector(
    getIngredientEntriesMap,
    entriesMap => {
      let entriesWithIds = List();
      ids.forEach(id => {
        if (entriesMap.has(id)) {
          entriesWithIds = entriesWithIds.push(entriesMap.get(id));
        }
      });
      return entriesWithIds.sortBy(entry => entry.get('lineId'));
    }
  );
